/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { ZoomOutCommand } from './zoom-out.command';
import { MapInteractionsService } from '../../services/mapInteractions.service';

export function zoomOutFactory() {
    const command = new ZoomOutCommand();
    command.setDependencies({
        interactions: inject(MapInteractionsService)
    });
    return command;
}
